import axios from 'axios'
import config from '@/config'

const candidateManagementService = {
  getCompanyCandidateList(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 + `/profile/candidate/list/bycompany?companyId=${data.companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getAppliedCandidateList(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/list/bycompany/applicant?companyId=${data.companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getBothCandidateList(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/list/bycompany/both?companyId=${data.companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getAppliedList(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/jobcode/bybookingid/appliedlist?bookingid=${data.bookingId}&companyid=${data.companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteApplicant(context, deleteApplicantModel) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/jobcode/delete/applicant',
        data: deleteApplicantModel,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  addRefrence(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/add/internalref',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getJobCodeAppliedCandidateComments(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/jobcode/bybookingid/appliedcandidate/comments?bookingid=${data.bookingId}&companyid=${data.companyId}&candidateemail=${data.candidateEmail}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  statusList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/candidatemanagement/statuslist',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  setStatus(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/candidatemanagement/setstatus',
        data: data,
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  sendCandidateComment(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `${
          data.productType === 'jobad' ? config.BASE_API_URL_V2 + '/jobad' : '/jobcode'
        }/appliedcandidate/comments`,
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  saveShareLink(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/profile/candidate/generateapplicantlink`,
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getShareLink(email, booking) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/generateapplicantlink?targetEmail=${email}&bookingId=${booking}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  sendShareCandidateEmail(_data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/profile/candidate/email/link`,
        data: _data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getSharedCandidateLink(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/generateapplicantlink?targetEmail=${data.targetEmail}&bookingId=${data.bookingId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  inviteCandidatesToJob(_data, success, error) {
    axios({
      method: 'POST',
      url: config.BASE_API_URL + `/cm/invite/candidate`,
      data: { ..._data, serverRoute: `${config.BASE_API_LOGIN_URL}/job-interview` }, // /${data.jobCodeId}/${data.uniqueId}
    })
      .then(res => success(res.data))
      .catch(err => error(err.response))
  },
  sendReminder(_data) {
    // For 'Send reminder'and for resending email
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + `/cm/invite/candidate/sendemail`,
        data: { ..._data },
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  getInvitedCandidateList(bookingId, auth) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL +
          `/cm/invite/candidate/list?bookingId=${bookingId}${auth ? '&noAuth=true' : ''}`,
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  getCandidateAnswers(bookingId, companyId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL +
          `/jobcode/bybookingid/questionwise/videoanswer?bookingid=${bookingId}&companyid=${companyId}`,
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  cancelEmailInvite(uid) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + `/cm/invite/cancel`,
        data: { uniqueId: uid },
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  cancelRecruiterInvite(email, bookingId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + `/cm/invite/candidate/cancel`,
        data: { candidateEmail: email, bookingId: bookingId },
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  deleteRecruiterInvite(email, bookingId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + `/cm/invite/candidate/cancel`,
        data: { candidateEmail: email, bookingId: bookingId, isDelete: true },
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  updateComments(request) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + `/jobcode/appliedcandidate/comments/update`,
        data: request,
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
  deleteComments(request) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + `/jobcode/appliedcandidate/comments/delete`,
        data: request,
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err.response))
    })
  },
}

export default candidateManagementService
